import Vue from 'vue';


//=============GF Module Vue Files========================//

// Added by Mustafijur 

// Vue.component('gf-contribution-list', require('./components/gf_components/GFContributionList.vue').default);
Vue.component('gf-settings', require('./components/GFSettings.vue').default);
Vue.component('gf-general-settings', require('./components/GFGeneralSettings.vue').default);
Vue.component('gf-contribution-process-policy', require('./components/GfContributionProcessPolicy.vue').default);
Vue.component('gf-settlement-policy', require('./components/GfSettlementPolicy.vue').default);
Vue.component('gf-reasons-for-separation', require('./components/GFReasonsForSeparation.vue').default);
Vue.component('gf-reasons-for-separation-slabs', require('./components/GFReasonsForSeparationSlabs.vue').default);

//============GF Components by Ali ==========================//

// General Files
Vue.component('employee-mgf-info', require('./components/EmployeeMgfInfo.vue').default); // new 26th may 2022
Vue.component('company-gf-settings', require('./components/GFSettings.vue').default);
Vue.component('gf-wizard', require('./components/GFWizard.vue').default); // 28th June 2022
// Vue.component('gfsignup', require('./components/GFSignup.vue').default); // 28th June 2022 
Vue.component('gf-registered-list', require('./components/GFRegisteredList.vue').default); // 28th June 2022 
Vue.component('gf-enrollment-list', require('./components/GFEnrollmentList.vue').default); // 28th June 2022 

// Vue.component('gf-distribution',require('./components/GFDistribution.vue').default);// 9 Nov 2021 
Vue.component('gf-de-registration',require('./components/GFDeRegistration.vue').default);// 9 Nov 2021 
Vue.component('search-employee-gf', require('./components/GfSearchEmployee.vue').default);// 9 Nov 2021 
// Vue.component('gf-reclaim-list', require('./components/GFReclaimList.vue').default);// 16th August 2021
Vue.component('gf-reporting', require('./components/GfReporting.vue').default);// 8 DEC 2021
Vue.component('gf-employee-profile-report', require('./components/GFEmployeeProfileReport.vue').default);// 8 DEC 2021
Vue.component('gf-monthly-report', require('./components/GFMonthlyReport.vue').default);// 8 DEC 2021
Vue.component('gf-monthly-leaver-report', require('./components/GFMonthlyReportLeaver.vue').default);// 8 DEC 2021
Vue.component('gf-fiscal-report', require('./components/GFFiscalReport.vue').default);// 13 DEC 2021
Vue.component('gf-pl-report', require('./components/GFProfitLossReport.vue').default);// 13 DEC 2021
Vue.component('gf-bs-report', require('./components/GFBalanceSheetReport.vue').default);// 13 DEC 2021
Vue.component('gf-profit-distribute-report', require('./components/GFProfitDistributeReport.vue').default);// 15 DEC 2021
Vue.component('gf-profit-payable-report', require('./components/GFProfitPayableReport.vue').default);// 15 DEC 2021
// Vue.component('gf-employee-import', require('./components/GFEmployeesImport.vue').default);// 21 JAN 2022
Vue.component('all-gf-contributions', require('./components/AllGFContributions.vue').default);
Vue.component('gf-contributions', require('./components/GfContributions.vue').default);
Vue.component('gf-retirement-report', require('./components/GFRetirementReport.vue').default);// 7 July 2022
Vue.component('gf-eligible-employees-report', require('./components/GfEligileEmployeesReport.vue').default); // Rejwan: gf_unified
Vue.component('gf-final-settlement-payable-details-report', require('./components/GfFinalSettlementPayableDetailsReport.vue').default); // Rejwan: gf_unified
Vue.component('gf-payment-report', require('./components/GfPaymentReport.vue').default); // Rejwan: gf_unified


// GF Loan Files
Vue.component('gf-loan',require('./components/GFLoan.vue').default);// 9 Nov 2021 
Vue.component('gf-loan-applications', require('./components/GfLoanApplicationList.vue').default);// 9 Nov 2021 
Vue.component('gf-loan-form', require('./components/GFLoanForm.vue').default);// 9 Nov 2021 
Vue.component('gf-loan-transactions-wizard', require('./components/GfLoanTransactionWizard.vue').default);// 9 Nov 2021 
Vue.component('gf-loan-profile-list', require('./components/GfLoanProfileList.vue').default);// 9 Nov 2021 
Vue.component('gf-loan-wizard', require('./components/GfLoanWizard.vue').default);// 9 Nov 2021 
Vue.component('gf-employee-loan-list', require('./components/GfEmployeeLoanList.vue').default);// 16th August 2021 
Vue.component('gf-loan-public-info', require('./components/GfLoanPublicInfo.vue').default);// 1 DEC 2021
Vue.component('gf-loan-monthly-report', require('./components/GFLoanMonthlyReport.vue').default); // 11 FEB 2022
Vue.component('gf-loan-schedule-report', require('./components/GFLoanScheduleReport.vue').default); // 11 FEB 2022

Vue.component('gf-settlement-list', require('./components/GFSettlementList.vue').default); // 11 FEB 2022


// GF Only Package Files
Vue.component('gf-runs', require('./components/GFruns.vue').default);// 11 MAY 2022

Vue.component('gf-run-wizard', require('./components/GFrunwizard.vue').default);// 11 MAY 2022

Vue.component('gf-run-payslips', require('./components/GFrunpayslips.vue').default);// 11 MAY 2022

Vue.component('gf-company-dashboard', require('./components/GFCompanyDashboard.vue').default);// 11 MAY 2022


Vue.component('employee-wizerd-gf-only', require('./components/EmployeeWizardGfOnly.vue').default);  //  Ali 29-7-2022

Vue.component('employeegfslips', require('./components/EmployeeGFslips.vue').default);//  Ali 29-7-2022
Vue.component('Employeegfslipdetails', require('./components/EmployeeGFSlipDetails.vue').default);//  Ali 29-7-2022


Vue.component('gf-acturial-list', require('./components/GFActurialList.vue').default);//  Ali 29-04-2025
Vue.component('gf-acturial-form', require('./components/GFActurialForm.vue').default);//  Ali 29-04-2025
Vue.component('gf-migrated-fund-form', require('./components/GFMigratedFundForm.vue').default);//  Ali 29-04-2025
Vue.component('gf-run', require('./components/GFRun.vue').default);//  Ali 29-04-2025 
Vue.component('gf-run-list', require('./components/GFRunList.vue').default);//  Ali 29-04-2025
Vue.component('gf-run-form', require('./components/GFRunForm.vue').default);//  Ali 29-04-2025
Vue.component('gf-run-view', require('./components/GFRunView.vue').default);//  Ali 29-04-2025

 
//==========================================================//



// ALI PF and GF Only Package //
Vue.component('pf-and-gf-company-dashboard', require('./components/PFandGFCompanyDashboard.vue').default);// 5 August 2022
Vue.component('employee-wizerd-pf-and-gf-only', require('./components/EmployeeWizardPfandGfOnly.vue').default);  //  5 August 2022
Vue.component('employeepfgfslips', require('./components/EmployeePFGFslips.vue').default); //  5 August 2022
Vue.component('Employeepfgfslipdetails', require('./components/EmployeePFGFSlipDetails.vue').default); //  5 August 2022
Vue.component('pf-gf-runs', require('./components/PFGFruns.vue').default);//  5 August 2022
Vue.component('pf-gf-run-payslips', require('./components/PFGFrunpayslips.vue').default);// 5 August 2022 
Vue.component('pf-and-gf-run-wizard', require('./components/PFGFrunwizard.vue').default);//  5 August 2022

// Start: Rejwan: 14-05-2025 Deregistration
Vue.component('gf-dereg-leaver-list', require('./components/GFDeregLeaverList.vue').default);
Vue.component('gf-dereg-manual', require('./components/GFDeregManual.vue').default);
Vue.component('gf-settlement-form', require('./components/GFSettlementForm.vue').default);
Vue.component('gf-settlement-dashboard', require('./components/GFSettlementDashboard.vue').default);
Vue.component('gf-loan-bank-data-form', require('./components/GFLoanBankDataForm.vue').default);
Vue.component('gf-loan-documents', require('./components/GFLoanDocuments.vue').default);
// End: Rejwan: 14-05-2025 Deregistration


// Start: Rejwan: 17-05-2025 Awaiting Disbursement
Vue.component('gf-awaiting-disbursement', require('./components/GFAwaitingDisbursement.vue').default);
// End: Rejwan: 17-05-2025 Awaiting Disbursement

// Start: Rejwan: 18-05-2025 Deferred Settlements
Vue.component('gf-deferred-settlement', require('./components/GFDeferredSettlement.vue').default); 
Vue.component('gf-settlement-rejected-list', require('./components/GFSettlementRejectedList.vue').default); 
Vue.component('gf-profile-overview', require('./components/GFOverview.vue').default);
// End: Rejwan: 18-05-2025 Deferred Settlements

// Start: GF Dashboard
Vue.component('gf-dashboard', require('./components/GFDashboard.vue').default);
Vue.component('gf-outgoing-members-bar', require('./components/gf/GFOutgoingMembersBar.vue').default);
Vue.component('gf-membership-status-chart', require('./components/gf/GFMembershipStatusChart.vue').default);
// End: GF Dashboard

// Start: Rejwan: 19-05-2025 GF Summary
Vue.component('gf-summary', require('./components/GFSummary.vue').default);
Vue.component('employee-gf-profile-overview', require('./components/EmployeeGFOverview.vue').default);
Vue.component('gf-settlement-form-quick-view', require('./components/GFSettlementFormQuickView.vue').default);
Vue.component('gf-settlement-documents', require('./components/GFSettlementDocuments.vue').default);
Vue.component('gf-settlement-approval-section', require('./components/GFSettlementApprovalSection.vue').default);
Vue.component('gf-settlement-on-hold', require('./components/GFSettlementOnHold.vue').default);
Vue.component('gf-settlement-disbursed', require('./components/GFSettlementDisbursed.vue').default);
Vue.component('gf-settlement-awaiting-approval', require('./components/GFSettlementAwaitingApproval.vue').default);
// End: Rejwan: 19-05-2025 GF Summary


// Start: Rejwan: 21-05-2025 Profit Distribution
// Vue.component('gf-distribute-profit-form', require('./components/GFDistributeProfitForm.vue').default);
// Vue.component('gf-distribute-details', require('./components/GFDistributeDetails.vue').default);
// Vue.component('gf-profit-table', require('./components/GFProfitTable.vue').default);
// End: Rejwan: 21-05-2025 Profit Distribution

// Start: Rejwan: 26-05-2025 Migrated Gf History
// Vue.component('employee-migrated-gf-history', require('./components/EmployeeMigratedGfHistory.vue').default);
// End: Rejwan: 26-05-2025 Migrated Gf History

// Start: Rejwan: gf_unified
Vue.component('employee-gf-statement', require('./components/GfStatement.vue').default); // Rejwan: gf_unified

Vue.component('employee-gf-summery-front', require('./components/front/GfSummeryFront.vue').default); 
Vue.component('employee-gf-settlement-list-front', require('./components/front/GfSettlementListFront.vue').default); // 11 Dec 2024 
Vue.component('gf-settlement-form-quick-view-front', require('./components/front/GFSettlementFormQuickViewFront.vue').default);
Vue.component('gf-settlement-documents-front', require('./components/front/GFSettlementDocumentsFront.vue').default);
Vue.component('gf-settlement-approval-section-front', require('./components/front/GFSettlementApprovalSectionFront.vue').default);

// End: Rejwan: gf_unified